import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { useRegionalLink } from 'hooks/useRegionalLink';

import { Company } from 'components/common/Elements/Elements';
import { access, hasAccess, resources } from 'utils/permissions';
import { recordType as getRecordType } from 'utils/common';

const Account = ({ data }) => {
  const { companyName, status, companySize, country, website, customerId } =
    data;
  const { url } = useRouteMatch();
  const generateRegionalPath = useRegionalLink();
  const hasSensitiveDataReadAccess = hasAccess([
    resources.TENANT_SENSITIVE_DATA,
    access.READ
  ]);
  const recordType = getRecordType(data);

  return hasSensitiveDataReadAccess ? (
    <NavLink
      to={generateRegionalPath(`${url}/${customerId}/platform/networks`)}
    >
      <Company
        nameCompany={companyName ? companyName : customerId}
        status={status}
        description={companySize}
        recordType={recordType}
        country={country}
        domain={website}
        customerId={customerId}
      />
    </NavLink>
  ) : (
    <Company
      nameCompany={companyName ? companyName : customerId}
      status={status}
      description={companySize}
      recordType={recordType}
      country={country}
      domain={website}
      customerId={customerId}
    />
  );
};

Account.propTypes = {
  data: PropTypes.shape({
    customerId: PropTypes.string,
    companyName: PropTypes.string,
    country: PropTypes.string,
    status: PropTypes.string,
    companySize: PropTypes.string,
    website: PropTypes.string
  })
};

export default Account;
